import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { AppUpdateService } from './common/services/app-update/app-update.service';
import { LoaderService } from './common/services/loader/loader.service';
import { NotificationCenterService } from './common/services/notification-center/notification-center.service';

@Component({
  selector: 'app-root',
  template: `<router-outlet />
    <loader-lock-screen *ngIf="isLoading" /> `,
})
export class AppComponent implements OnInit {
  isLoading = false;

  constructor(
    private loaderService: LoaderService,
    private notificationCenter: NotificationCenterService,
    private appUpdateService: AppUpdateService,
    cdr: ChangeDetectorRef
  ) {
    this.loaderService.isLoading.subscribe({
      next: (value) => {
        this.isLoading = value ?? false;
        cdr.detectChanges();
      },
    });
  }

  ngOnInit() {
    this.notificationCenter.bootstrap();
    this.appUpdateService.start();
  }
}
